import React, { Component } from 'react';
import { OxxoReferenceModel } from '../NewOrder';
import moment from 'moment';
import { ApiClient } from "../../libs/apiClient";
import { connect } from "react-redux";
import { CURRENCY, DISPATCH_ID, SYMBOL, FORMAT_NUMBER } from "../../libs/utils/Const";
import VoucherPDFComponent from './VoucherPDFComponent';

const apiClient = ApiClient.getInstance();


class OxxoReferenceInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            model: new OxxoReferenceModel()
        }
    }

    async componentDidMount() {
        await this.CallSearchInfo();
    }

    CallSearchInfo = async (recentlyGenerated = null) => {
        const { DocEntry, ObjType, ObjSubType, Param, IdOxxoRef } = this.props
        await this.SearchOxxoRefByProps(DocEntry, ObjType, ObjSubType, Param, recentlyGenerated !== null ? recentlyGenerated : IdOxxoRef);

    }

    SearchOxxoRefByProps = async (DocEntry = null, ObjType = null, ObjSubType = null, Param = null, IdOxxoRef = null) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        if (!IdOxxoRef) return;

        const data = {
            DocEntry,
            ObjType,
            ObjSubType,
            Param,
            IdOxxoRef,
        }

        enableSpinner(true);
        const responseApi = await apiClient.GetInfoOxxoReference(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error' });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message ?? '' });
        if (responseApi.data.ModelReference) {
            const fillModel = await this.FillInfoWithData(responseApi.data.ModelReference);
            await this.setState({
                model: fillModel
            })
        }
    }

    GenerateOxxoRef = async () => {
        const { DocEntry, ObjType, ObjSubType, Param, IdOxxoRef } = this.props
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        if (!DocEntry || !ObjType || !ObjSubType || !Param) {
            showAlert({ type: 'info', timeOut: 5000, message: `Falta información del documento para generar la referencia Oxxo` });
            return
        }

        const data = {
            DocEntry,
            ObjType,
            ObjSubType,
            Param,
            IdOxxoRef,
        }

        enableSpinner(true);
        const responseApi = await apiClient.GenerateOxxoRef(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error' });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message ?? '' });
        await this.CallSearchInfo(responseApi.data);
    }

    FillInfoWithData = (infoBack) => {
        let model = new OxxoReferenceModel();
        model = infoBack;
        return model
    }



    render() {

        const { model } = this.state
        return (
            <div className="row">
                <div className="col-12 col-md-6">

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.Reference || ''}
                        />
                        <button type="button" className="input-group-text" disabled={(model.Reference && model.Reference !== '') ? true : false}
                            style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={() => this.GenerateOxxoRef()}>
                            <i className="fa fa-refresh fa-lg" />
                        </button>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cliente</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.RefNumericPartner || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha vencimiento</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={moment(model.DueDate ?? new Date()).format('YYYY-MM-DD') || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={CURRENCY + ' ' + FORMAT_NUMBER.new(Number(model?.RefTotal ?? 1) / 100 || '')}
                        />
                    </div>
                    {(model?.Reference && model?.Reference !== '') &&
                        <VoucherPDFComponent
                            reference={model}
                        />
                    }
                </div>

                <div className="col-12 col-md-6">

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Usuario creador</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.CreateUser || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha creación</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.CreateDate || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={defineDocByType(model.ObjType) || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Documento</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={(model.DocNum) || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">ID único documento</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.DocEntry || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Folio</span>
                        </div>
                        <input type="text" className="form-control input-sm" disabled="true"
                            value={model.NumAtCard || ''}
                        />
                    </div>

                </div>
            </div>
        );
    }

}

const defineDocByType = (ObjType, ObjSubType) => {
    let typeDoc = '';
    switch (Number(ObjType)) {
        case 13:
            typeDoc = 'Factura';
            break;

        default:
            break;
    }
    return typeDoc;
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        renderReducer: store.RenderReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setPrintToDocumentsModal: value => dispatch({ type: DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OxxoReferenceInfo);


// export default ;